import React from 'react';

type Props = {
  text?: string;
};

export default function Divider({ text }: Props) {
  if (!text) {
    return <hr className="border-t" />;
  }

  return (
    <div className="flex items-center justify-center gap-4">
      <hr className="flex-grow border-t" />
      <small className="low-emphasis-text font-medium">{text}</small>
      <hr className="flex-grow border-t" />
    </div>
  );
}
